import React from 'react';

import { Stack } from '@mui/material';

const ListFlyoutPaperActionButton = ({ sx, children }) => <Stack sx={{ ...sx }}>{children}</Stack>;

export default ListFlyoutPaperActionButton;
